<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Modals</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <!--Large Modal-->
                <div class="large-modal">
                    <b-btn v-b-modal.modallg variant="primary">Large modal</b-btn>


                    <!--Large Modal Popup-->
                    <b-modal id="modallg" size="lg" title="Large Modal">
                        We use cookies to improve your website experience

                        <b-button>Learn More</b-button>
                        <b-button>OK, Thanks</b-button>
                    </b-modal>
                    <!--Large Modal Popup-->
                </div>
                <!-- Large Modal -->


            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../mixins/commonMixins';
    import EventBus from "./event-bus";

    Vue.component("app-footer", Footer);

    export default {
        name: 'Test',
        mixins: [commonMixins],
        data () {
            return {
                mySiteArr: []
            }
        },
        beforeMount() {
            self = this;
        },
        mounted: function() {
            self.setActiveMenu('test');
            EventBus.$emit("menu-selection-changed", "test");
        },
        methods: {
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Test.vue